
import vSelect from "vue-select"
import { Prop, Component, Vue } from "vue-property-decorator"
import { Template, CaseDetails } from "@/types"
import { namespace } from "vuex-class"

const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class TemplateSelect extends Vue {
	@caseStore.Getter("getCreatableCategories") public categories!: Template[] | null;

	@Prop({ required: true })
	public currentCase!: CaseDetails

	templateChanged (templateId: string) {
		this.$emit("templateChanged", templateId)
	}

	get newCase () {
		return !(this.currentCase.id)
	}
}
